import { getVariableOrThrow } from '../../../shared/utils';

export const redirectToSSWebApp = (token) => {
  const baseUrl = getVariableOrThrow('VUE_APP_SSWEBAPP_BASE_URL');
  const url = `${baseUrl}/api2/external_login/admin_hierarchy_jwt/`;
  fetch(url, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ token }),
  })
    .then(() => {
      window.location.href = baseUrl;
    })
    .catch((e) => {
      console.error(e);
    });
};
